<template>
    <properties-archive-update
        :uuid="property.uuid"
        @success="show_edit_modal = false; show_updated_modal = true"
    >
        <div
            slot-scope="{
                is_loading: is_saving,
                error,
                update,
                forget
            }"
        >
            <error-modal
                v-if="error"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_updated_modal"
                :is-open="show_updated_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Property Archived!</template>

                <p>Property successfully archived</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="btn text-center"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-red
                v-else-if="show_edit_modal"
                :is-open="show_edit_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="update"
                >
                    <div class="pt-4 pb-3 px-4 sm:p-6">
                        <h6 class="text-center font-semibold text-lg font-normal mb-3">
                            Archive Property
                        </h6>

                        <div class="text-grey-darker">
                            <p class="mb-3">
                                Archive properties you no longer need on Rentora. Doing so will hide them by default,
                                but can still be viewed if required for future reference.
                            </p>

                            <p class="mb-3">
                                <strong>Caution:</strong> By archiving this property, any of it's documents, tenancies, rents, etc will
                                also be archived - and the consiquences of doing so applied to them.
                            </p>

                            <p><strong>You cannot undo this action.</strong></p>
                        </div>
                    </div>

                    <footer class="flex flex-col md:flex-row-reverse bg-grey-bg rounded-b py-3 px-6">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="btn btn-red w-full md:w-auto"
                        >
                            Archive Property
                        </base-button>

                        <button
                            type="button"
                            class="btn text-center md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-red>
        </div>
    </properties-archive-update>
</template>

<script>
    import PropertiesArchiveUpdate from '../../../../../../components/properties-archive-update'

    export default {
        components: {
            PropertiesArchiveUpdate
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            property: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_edit_modal: this.toggled,
                show_updated_modal: false,
                form: {
                    ends_at: null
                }
            }
        },
        watch: {
            toggled () {
                this.show_edit_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_updated_modal = false
                this.show_edit_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_edit_modal = false
                this.show_updated_modal = true
            }
        }
    }
</script>
